import React from "react";
import { Alert, Fade } from "react-bootstrap";
import { connect } from "react-redux";
import * as redux from "redux";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    initialized: state.conn.initialized,
    displayWarning: state.conn.displayConnectedWarning,
    allConnected: state.conn.connected,
    apiConnected: state.conn.apiConnected,
    svcConnected: state.conn.servicesConnected,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
}

interface ConnectedState {
    displayWarning: boolean;
    initialized: boolean;
    allConnected: boolean;
    apiConnected: boolean;
    svcConnected: boolean;
}

interface ConnectedDispatch {
}

interface OwnState {
}

class ConnectionStatusComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {
    public render() {
        if (this.props.apiConnected && this.props.svcConnected)
            return null;

        const connected = this.props.apiConnected && this.props.svcConnected;
        const service = !this.props.apiConnected && !this.props.svcConnected
            ? "server"
            : (!this.props.apiConnected ? "API server" : "Services server");

        return <div className="site-notifications-wrapper">
            <div className="site-notifications" style={{ position: "fixed", bottom: "10px" }}>
                <Fade in={this.props.initialized && !connected}>
                    <div className="item">
                        <Alert bsStyle="warning">
                            <p>Could not reach {service}.{this.props.displayWarning ? " Are you connected to the internet?" : " Trying to reconnect..."}</p>
                        </Alert>
                    </div>
                </Fade>
            </div>
        </div>
        ;
    }
}

export const ConnectionStatus: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(ConnectionStatusComponent);



// WEBPACK FOOTER //
// ./src/components/generic/ConnectionStatus.tsx